import React from 'react';
import { Layout } from '../../components/layout/Layout';
import { PageHero, ContentSection, SEOContent, CTASection } from '../../components/shared';

export const HausbesuchePage = () => {
  return (
    <Layout>
      <PageHero
        title="Hausbesuche: Medizin kommt zu Ihnen"
        subtitle="Wir versorgen Sie auch zu Hause, wenn Sie nicht in unsere Praxis kommen können."
        backgroundImage="/images/Hausbesuche.webp"
        ctaText="Hausbesuch anfragen"
      />

      <ContentSection
        title="Versorgung mit Sorgfalt – auch zu Hause"
        content="Für Patienten, die aufgrund ihres Gesundheitszustandes oder ihrer eingeschränkten Mobilität nicht in der Lage sind, unsere Praxis aufzusuchen, bieten wir regelmäßige Hausbesuche an. Wir kommen zu Ihnen nach Hause, um medizinische Versorgung zu leisten, Diagnosen zu stellen und Behandlungspläne zu erstellen."
        image="/images/Hausbesuche.webp"
        backgroundColor="white"
      />

      <SEOContent
        title="Mobiler Arzt-Service für Diez und Umgebung"
        content="Wenn ein Besuch in der Praxis nicht möglich ist, sorgt die Gemeinschaftspraxis Dres. von Bergh für Ihre medizinische Versorgung durch Hausbesuche im Raum Diez."
      />

      <CTASection
        title="Sie oder ein Angehöriger benötigen einen Hausbesuch?"
        subtitle="Kontaktieren Sie uns, um die Möglichkeiten zu besprechen und einen Termin zu vereinbaren."
        buttonText="Termin anfragen"
      />
    </Layout>
  );
};

export default HausbesuchePage;
